<ion-header [translucent]="true" class="ion-no-border">
  <ion-toolbar color="color1">
    <ion-buttons slot="start" style="color: white;">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-row>
      <ion-col size="10"> <ion-title style="  margin-top: 4px;" class="title">{{title}}</ion-title></ion-col>
      <ion-col size="2" style="text-align: center;padding-top: 5px;" (click)="GoToNoti()"> <ion-icon style="color: white;font-size: 25px;"
          name="notifications-outline"></ion-icon></ion-col>
    </ion-row>

    <!-- <ion-row *ngIf="isSubExpired">
      <ion-col size="8.5">  <ion-title class="title">{{title}}</ion-title></ion-col>
      <ion-col size="3.5" style="text-align: end;"> <ion-label class="blink_me">Expired</ion-label></ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" *ngIf="!isSubExpired">  <ion-title class="title">{{title}}</ion-title></ion-col>
    </ion-row> -->

  </ion-toolbar>
</ion-header>